import { TagBoxBounds } from '../TagBoxBounds.js';

export class JQueryUIDraggableAdapter {
    // Attaches jQuery UI draggable to $el and forwards lifecycle events via callbacks.
    // Bounds-clamping is handled internally — callers receive already-clamped positions.
    // onStart may return false to cancel the drag (e.g. when autocomplete is open).
    attach($el, { getBounds, onStart, onDrag, onStop }) {
        $el.draggable({
            start(ev) {
                if (onStart(ev) === false) return false;
            },
            drag(event, ui) {
                const bounds = getBounds();
                const clamped = TagBoxBounds.clamp(
                    { left: ui.position.left, top: ui.position.top },
                    { width: $el.outerWidth(), height: $el.outerHeight() },
                    bounds
                );
                ui.position.left = clamped.left;
                ui.position.top  = clamped.top;
                onDrag();
            },
            stop() { onStop(); },
        });
    }
}
